import { ProductKind } from 'constants/product'

/** Evaluates if selected kind belongs in Editing ProductKind enum and returns a boolean value */
export const isEditingFloorPlanProductKind = (selectedKind: ProductKind) => {
  return selectedKind === ProductKind.FLOOR_PLAN_EDITING_2D || selectedKind === ProductKind.FLOOR_PLAN_EDITING_3D
}
